import {
    getHours,
    isToday
} from "date-fns";
import { DeliveryService } from "./DeliveryService";
import { addDays } from "../components/utils/stateHelper";


export class TFDeliveryService extends DeliveryService {

    /////////////////////////////////////////////////////
    // Functions related to Transforce logistics
    /////////////////////////////////////////////////////

    /**
     * The soonest that a play date can be scheduled, given a particular startDate
     */
    public static earliestPlayStartAfter(startDate: Date) {
        return addDays(TFDeliveryService.earliestDeliveryDateAfter(startDate), 1);
    }

    /**
     * If the date is today, and it's after 12:59pm, the start date must be the next business day.
     * In all other cases, the start date is the same as the given date.
     */
    public static earliestStartDateAfter(date: Date) {
        if (isToday(date) && getHours(date) > 12 && DeliveryService.isWorkingDate(date)) {
            return DeliveryService.addBusinessDays(date, 1);
        } else {
            return date;
        }
    }

    /**
     * The earliest delivery date (delivery date < play start < return date) that can be achieved
     * given a pre-start date (the pre-start date may also turn into the start date).
     * 
     * One day after the earliest possible start date.
     */
    public static earliestDeliveryDateAfter(date: Date) {
        // Transforce can do next day shipping
        return this.addBusinessDays(this.earliestStartDateAfter(date), 1);
    }

    /**
     * The day on which a package must be shipped (startDate) to arrive the business day before the given
     * playStart.
     */
    public static latestShippingDateBefore(playStart: Date) {
        return DeliveryService.subtractBusinessDays(playStart, 2);
    }

    /**
     * The first day on which a package can be picked up
     */
    public static earliestReturnDateAfter(playEnd: Date) {
        return DeliveryService.addBusinessDays(playEnd, 1);
    }

    /**
     * The day we expect to have the package back given the return pickup date
     */
    public static endDateByReturnDate(returnDate: Date) {
        return DeliveryService.addBusinessDays(returnDate, 1)
    }
}
